import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useAdventPassStatus = () => {
  const { data: session } = useQuery({
    queryKey: ['session'],
    queryFn: async () => {
      const { data } = await supabase.auth.getSession();
      return data.session;
    },
  });

  return useQuery({
    queryKey: ['advent-pass-status', session?.user?.id],
    queryFn: async () => {
      if (!session?.user) return { hasAdventPass: false, expiresAt: null, partnerCode: null };
      
      const { data, error } = await supabase
        .from('partner_code_redemptions')
        .select(`
          id,
          redeemed_at,
        partner_codes!inner(
          code,
          valid_from,
          valid_until,
          partner_name,
          discount_percentage,
          is_active,
          applies_to_tags
        )
        `)
        .eq('user_id', session.user.id)
        .eq('redemption_type', 'percentage')
        .eq('partner_codes.code', 'ADVENTPASS')
        .eq('partner_codes.is_active', true)
        .maybeSingle();
      
      if (error || !data) {
        return { hasAdventPass: false, expiresAt: null, partnerCode: null };
      }
      
      const partnerCode = data.partner_codes;
      const isValid = !partnerCode.valid_until || new Date(partnerCode.valid_until) > new Date();
      
      return {
        hasAdventPass: isValid,
        expiresAt: partnerCode.valid_until ? new Date(partnerCode.valid_until) : null,
        partnerCode: partnerCode,
      };
    },
    enabled: !!session?.user,
  });
};
